import { render, staticRenderFns } from "./ErorrRecovery.vue?vue&type=template&id=9283d9e6&scoped=true"
import script from "./ErorrRecovery.vue?vue&type=script&lang=js"
export * from "./ErorrRecovery.vue?vue&type=script&lang=js"
import style0 from "./ErorrRecovery.vue?vue&type=style&index=0&id=9283d9e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9283d9e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VIcon,VImg})
